import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { Lightbox } from 'ngx-lightbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { VgAPI } from 'videogular2/core';
import * as OT from '@opentok/client';

import { AlertService, ProctorService, OpentokService } from '../_services';
import { Globals } from '../_helpers';
import { SearchFilterPipe } from '../_pipes';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-livefeed',
    templateUrl: './livefeed.component.html',
    providers: [OpentokService]
})


export class LivefeedComponent implements OnInit {

    feedsettings: {};
    localData = {};

    session: OT.Session;
    streams: Array<OT.Stream> = [];
    streaming: OT.Stream;
    changeDetectorRef: ChangeDetectorRef;
    @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
    @ViewChild("videoPlayer") videoplayer: ElementRef;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private _lightbox: Lightbox,
        private spinner: NgxSpinnerService,
        private ref: ChangeDetectorRef,

        private opentokService: OpentokService
    ) { this.changeDetectorRef = ref; }

    link
    batchid

    ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        //this.localBatch = JSON.parse(localStorage.getItem('localBatch'));
        //this.localExam = JSON.parse(localStorage.getItem('localExam'));

        this.link = this.localData['link']
        this.batchid = this.localData['batchId']

        if (this.link == undefined || this.link == null) {
            if (this.localData['is_proctoring'] != 1)
                this.router.navigateByUrl('/login');
        }
        this.getfeed();
    }
    subscriber;
    private getfeed() {
        //this.spinner.show();
        //this.feedsettings = JSON.parse(sessionStorage.pkshn_ls_setting);
        this.feedsettings = JSON.parse(localStorage.getItem('pkshn_ls_setting'));
        //console.log(this.feedsettings);  
        //return;
        this.feedsettings['sid'] = '2_MX40NjIzOTIwMn5-MTY0MDg2MjIyNjA0OX5UbDRWUDE1NHBpaTlMSGJjZmdKL2RTWHN-fg';
        this.feedsettings['tid'] = 'T1==cGFydG5lcl9pZD00NjIzOTIwMiZzaWc9NzE5OTU4ZWFhMzk2NTI3ZjcyZTU4ODBmNWUzMDFlNDU1ZWZiZmEzNTpzZXNzaW9uX2lkPTJfTVg0ME5qSXpPVEl3TW41LU1UWTBNRGcyTWpJeU5qQTBPWDVVYkRSV1VERTFOSEJwYVRsTVNHSmpabWRLTDJSVFdITi1mZyZjcmVhdGVfdGltZT0xNjQwODYyMjI2Jm5vbmNlPTAuOTczMjQzODc5MTQ1MzQwNCZyb2xlPXB1Ymxpc2hlciZleHBpcmVfdGltZT0xNjQwOTQ4NjI2JmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9';
        /*this.opentokService.initSession(this.feedsettings['tid'], this.feedsettings['sid']).then((session: OT.Session) => {
                            //this.opentokService.initSession('46239202', this.SESSION_ID).then((session: OT.Session) => {
                                this.session = session;
                                this.session.on('streamCreated', (event) => {
                                    console.log('connect stream');
                                    this.streams.push(event.stream);
                                    this.subscriber = this.session.subscribe(event.stream, this.subscriberDiv.nativeElement, {}, (err) => {
                                        if (err) {
                                            console.log(err.message);
                                        }
                                        else{
                                            console.log('connect subscriber'); 
                                            //this.spinner.hide();
                                        }
                                    });
                                    this.changeDetectorRef.detectChanges();
                                });
                                this.session.on('streamDestroyed', (event) => {
                                    const idx = this.streams.indexOf(event.stream);
                                    if (idx > -1) {
                                        this.streams.splice(idx, 1);
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            })
                                .then(() => this.opentokService.connect())
                                .catch((err) => {
                                    if (err) {
                                        console.log(err.message);
                                        //this.globals.statusOpen(err.message);
                                    }
                                    else
                                    {
                                        console.log('conect publisher');
                                    }
                                }); */       
console.log(this.feedsettings);  
 this.session = OT.initSession('46239202',this.feedsettings['sid']);
                            //this.session = session;
                            console.log(this.session);
                            var handleError;
                            this.session.on('streamCreated', function(event) { 
                                console.log('connect stream');
                                    //this.streams.push(event.stream);
                                    this.session.subscribe(event.stream, 'subscriberDiv', {
                                      insertMode: 'append',
                                      width: '50%',
                                      height: '40%'
                                    }, handleError);
                                  });    
                            this.session.on('streamDestroyed', function(event) {

                            /*console.log("This student have disconnected!!");
                            if(!this.session)
                                {
                                this.session.off();
                                this.session.disconnect(); 
                                } */         
                            });
      
                          this.session.connect(this.feedsettings['tid'], function(error) {
                            // If the connection is successful, initialize a publisher and publish
                            // to the session
                            if (error) {
                              console.log("connection problem");
                            } else {
                             
                            }
                            
                          });

    }
}


